// extracted by mini-css-extract-plugin
export default {"ratingResultsContainer":"cartonchecss_ratingResultsContainer__BDzfh","bookBlock":"cartonchecss_bookBlock__NrERn","coverImage":"cartonchecss_coverImage__DQa-J"};